// File: frontend/src/pages/BlogPage.js
import React, { useState, useEffect } from 'react';
import { client } from '../contentfulClient'; 
import { Link } from 'react-router-dom';
import './BlogPage.css'; 

const BlogPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch posts from Contentful
    client.getEntries({
      'content_type': 'post' 
    })
    .then((response) => {
      setPosts(response.items);
      setLoading(false);
    })
    .catch((error) => {
      console.error("Error fetching posts from Contentful:", error);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div className="blog-page-container">
        <div className="loading-container">
            <p>Loading articles...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-page-container">
      <h1 className="blog-title">The FullMockup Blog</h1>
      <p className="blog-subtitle">
        Tips, tutorials, and inspiration for your e-commerce brand.
      </p>

      <div className="blog-grid">
        {posts.map((post) => {
          const { title, slug, featuredImage } = post.fields;
          
          return (
            <Link to={`/blog/${slug}`} key={post.sys.id} className="blog-post-card">
              
              {/* Image Wrapper for Zoom Effect */}
              {featuredImage && (
                <div className="blog-image-wrapper">
                    <img 
                      className="blog-card-image"
                      src={featuredImage.fields.file.url} 
                      alt={featuredImage.fields.description || title}
                    />
                </div>
              )}
              
              <div className="blog-card-content">
                <h3 className="blog-card-title">{title}</h3>
                
                <div className="blog-card-footer">
                    Read Article <span>&rarr;</span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default BlogPage;